import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export default {
  currentImage: function currentImage(state) {
    return state.currentImage;
  },
  productInspiration: function productInspiration(state) {
    return state.productInspiration;
  },
  productCross: function productCross(state) {
    return state.productCross;
  },
  productComplementary: function productComplementary(state) {
    return state.productComplementary;
  },
  variants: function variants(state) {
    return state.variants;
  },
  product: function product(state) {
    return state.product;
  }
};